module.exports = __webpack_public_path__ + "static/media/cohost-badge.73f54684.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cohost-badge.png
// module id = 1976
// module chunks = 0